import React from 'react'
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Useletter from './Useletter';
import Foter from './Foter';
function Skin() {
  return (
    <div>
      <Container>

        
<Row>
<Col xs={12} md={3}><div className="para">
  <div className="item">   
<div id="shop"><b>Shopping Now</b></div>

  <div id="line"></div>
  <div id="cate">CATEGORY</div>
  <div id="line"></div>
  <div id="cate">FRAGRANCE CATEGORY</div>
  <div id="line"></div>
  <div id="cate">SIZE</div>
</div></div></Col>

<Col xs={12} md={3}>
  <div className="box-content">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_protection_3_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div>

  </Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_protection_3__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<button className='bt'> ADD TO BAG</button>
</div></Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_perfection_resized_2_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div></Col>

</Row>
</Container>





<Container>

  
<Row>
<Col xs={12} md={3}></Col>
<Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_generation_3_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<button className='bt'> ADD TO BAG</button>
</div></Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_esduction_1_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div></Col>
<Col xs={12} md={3}>
  <div className="box-content">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/h/a/hand_cream_2_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div>

  </Col>

</Row>
</Container>



<Container>

  
<Row>
<Col xs={12} md={3}></Col>
<Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/f/o/foot_cream_3_.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<button className='bt'> ADD TO BAG</button>
</div></Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_generation_3__2.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div></Col>
<Col xs={12} md={3}>
  <div className="box-content">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/l/a/la_generation_3__1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div>

  </Col>

</Row>
</Container>


<Container>

  
<Row>
<Col xs={12} md={3}></Col>
<Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/e/x/exclusive_intense_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<button className='bt'> ADD TO BAG</button>
</div></Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/j/a/janan_pour_femme_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div></Col>
<Col xs={12} md={3}>
  <div className="box-content">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/a/z/azbah_1__1_2.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div>

  </Col>

</Row>
</Container>

<Container>

  
<Row>
<Col xs={12} md={3}></Col>
<Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/e/d/edge_1__1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>
<button className='bt'> ADD TO BAG</button>
</div></Col>
  <Col xs={12} md={3}> <div className="box-content">
<div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/2/_/2_24_188_1_1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
alt=''style={{height:'250px', width:'100%',

}} /></div>
<br /><br />
<div className="hiding"><p>YELLOW CAMBRIC PRINTED 

<br />
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div></Col>
<Col xs={12} md={3}>
  <div className="box-content">
  <div className="img-box"><img src="https://www.junaidjamshed.com/media/catalog/product/w/h/white_musk1_1.jpg?optimize=medium&bg-color=255,255,255&fit=bounds&height=755&width=589&canvas=589:755&dpr=2"
     alt=''style={{height:'250px', width:'100%' }} /> </div>
<br /><br />
<div className="hiding"><p>BROWN CAMBRIC PRINTED <br/>
<b>PKR 2,590.00</b>
</p>
</div>

<button className='bt'> ADD TO BAG</button>
</div>

  </Col>

</Row>
</Container>
<Useletter/>
<Foter/>
    </div>
  )
}

export default Skin
